import { Component, h, Prop, State } from '@stencil/core';
import { pathStore } from '@store/path-store';
import { handleRedirectWithDisclaimerLogic } from '@utils/utilities';
import { Disclaimer } from '../../shared/types';
import { UnbeatableDealsSectionProps } from './types';

@Component({
  tag: 'section-unbeateable-deals',
  styleUrl: 'section-unbeateable-deals.scss',
  shadow: true
})
export class SectionUnbeateableDeals {
  @Prop() data: UnbeatableDealsSectionProps;

  // Redirect Popup Related Code
  @State() showRedirectPopup: boolean = false;
  @State() redirectPopupContentType: string;
  @State() redirectTargetUrl: string = '';
  @State() disclaimerContent: Disclaimer

  handleRedirectProceed = () => {
    if (this.redirectTargetUrl) {
      window.location.href = this.redirectTargetUrl;
    }
  };

  handleRedirectClose = () => {
    this.showRedirectPopup = false;
  };

  onCardClick = (event: Event, item) => {
    event.stopPropagation();
    event.preventDefault();

    const { redirectUrl, disclaimer_popup, openRedirectUrlInNewTab } = item;

    const result = handleRedirectWithDisclaimerLogic({
      redirectUrl: redirectUrl,
      disclaimerSlug: disclaimer_popup?.slug,
      openInNewTab: openRedirectUrlInNewTab
    });

    if (result.showPopup) {
      this.redirectPopupContentType = result.contentType;
      this.redirectTargetUrl = result.redirectUrl;
      this.disclaimerContent = result.disclaimerContent;
      this.showRedirectPopup = true;
    }
  };

  render() {
    const assetPath = pathStore.assetPath;

    return (
      <div class="p-4">
        <div class="flex justify-between py-4">
          <p class="text-base font-bold text-black leading-6">{this.data?.title}</p>
          {this.data.viewAllLink && (
            <a href={this.data?.viewAllLink}>
              <img src={`${assetPath}images/icons/right_circle_arrow.svg`} alt={`${this.data?.title}`} height="16" />
            </a>
          )}
        </div>
        <div class="grid grid-cols-2 gap-4">
          {this.data?.smart_buy_card_benefits?.map(item => (
            <discover-card
              key={item.documentId}
              cardTitle={item.service}
              savePercentage={item.savings}
              RP={`${item.rewards}X`}
              bg={item?.image?.url}
              onClick={e => this.onCardClick(e, item)}
            />
          ))}

          {this.showRedirectPopup && (
            <redirect-popup
              open={this.showRedirectPopup}
              contentType={this.redirectPopupContentType}
              onConfirm={this.handleRedirectProceed}
              onClose={this.handleRedirectClose}
              redirectTargetUrl={this.redirectTargetUrl}
            />
          )}
        </div>
      </div>
    );
  }
}
